import React, { useEffect } from "react";

import { CHANGE_PASSWORD_URL } from "~/src/config";
import { useNavigationContext } from "~/src/nav";

import useAuth from "~/src/auth/hooks/use-auth";
import Spinner from "~/src/components/full-screen-spinner";
import { useHistory } from "react-router";

function ChangePassword() {
  const auth = useAuth();
  const navigationContext = useNavigationContext();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (navigationContext.isInternalNavigation) {
        const form = document.createElement("form");

        form.action = CHANGE_PASSWORD_URL;
        form.method = "POST";

        const tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "token";
        tokenInput.value = auth.token;

        form.appendChild(tokenInput);

        const brandInput = document.createElement("input");
        brandInput.type = "hidden";
        brandInput.name = "brand";
        brandInput.value = "rota";

        form.appendChild(brandInput);
        document.body.appendChild(form);
        form.submit();
      } else {
        history.push("/");
      }
    })();
  }, [navigationContext.isInternalNavigation, ...auth.deps]);

  return <Spinner />;
}

export default ChangePassword;
